<div class="p-20 fx-row fx-wrap align-items-center justify-content-start ">
<ng-container *ngIf="step === 'OPTIONS'">
  <div class="fx-flex-100 align-items-center justify-content-center text-center">
    <span class="title mb-10 text-center">{{'EVIDENCE_RECORDS.GENERATION_DIALOG_TITLE' | translate}}</span>
  </div>
  <span class="text mt-20">{{'EVIDENCE_RECORDS.GENERATION_DIALOG_INSTRUCTIONS' | translate}}</span>
  <span class="text mt-10" *ngIf="rejectedDocumentsCount > 0">
    {{'EVIDENCE_RECORDS.REJECTED_DOCUMENTS_EXCLUDED' | translate: { n: rejectedDocumentsCount } }}
  </span>
  <div class="fx-flex-100 fx-row fx-wrap align-items-center justify-content-center mv-20">
    <form [formGroup]="generationOptionsForm" class="fx-column">
      <div *ngFor="let control of groupByArray.controls; let i = index" class="group-by fx-row">
        <mat-select [formControl]="control" class="fx-flex-100 fx-column" color="primary">
          <mat-option *ngFor="let option of getGroupByValidOptions(i)" [value]="option" class="my-auto">
            {{ 'EVIDENCE_RECORDS.GROUPBY_TYPES.' + option | translate }}
          </mat-option>
        </mat-select>
        <button mat-icon-button color="warn" class="my-auto" (click)="removeGroupBy(i)"
          [disabled]="groupByArray.length <= 1">
          <mat-icon>delete_forever</mat-icon>
        </button>
      </div>
      <button class="button w-100" type="button" (click)="addGroupBy()">
        {{ 'EVIDENCE_RECORDS.ADD_GROUPBY_LEVEL' | translate }}
      </button>

      <div class="fx-column gap-20 mt-20">
        <mat-slide-toggle color="main" formControlName="includeDocumentDataPage">
          {{ 'EVIDENCE_RECORDS.INCLUDE_DOCUMENT_DATA_PAGE' | translate }}
        </mat-slide-toggle>
        <mat-slide-toggle roleBasedElement [roles]="annotateDocumentsOptionWhitelist" color="main"
                          formControlName="annotateDocuments">
        {{ 'EVIDENCE_RECORDS.ANNOTATE_DOCUMENTS' | translate }}
        </mat-slide-toggle>
      </div>
    </form>

  </div>
  <mat-divider class="fx-flex-100 mv-20"></mat-divider>
  <div class="fx-row align-items-center justify-content-center fx-flex-100">
    <button class="button fx-flex mr-10" (click)="onCancel()">{{'ACTIONS.CANCEL' | translate}}</button>
    <button class="main-button fx-flex ml-10" (click)="onConfirm()">{{'ACTIONS.CONFIRM' | translate}}</button>
  </div>
</ng-container>
<ng-container *ngIf="step === 'PENDING_DOCUMENTS'">
  <div class="fx-flex-100 align-items-center justify-content-center text-center">
    <span class="title mb-10 text-center">{{'EVIDENCE_RECORDS.PENDING_DOCUMENTS_TITLE' | translate}}</span>
  </div>
  <span class="text mt-20 fx-flex-100 text-center">
    {{'EVIDENCE_RECORDS.PENDING_DOCUMENTS_QUESTION' | translate: { n: pendingDocumentsCount } }}
  </span>
  <mat-divider class="fx-flex-100 mv-20"></mat-divider>
  <div class="fx-row align-items-center justify-content-center fx-flex-100 gap-16">
    <button class="button fx-flex" (click)="onReviewPendingDocuments()">
      {{'EVIDENCE_RECORDS.PENDING_DOCUMENTS_REVIEW' | translate}}
    </button>
    <button class="button fx-flex" (click)="onIncludePendingDocuments(false)">
      {{'EVIDENCE_RECORDS.PENDING_DOCUMENTS_EXCLUDE' | translate}}
    </button>
    <button class="main-button fx-flex" (click)="onIncludePendingDocuments(true)">
      {{'EVIDENCE_RECORDS.PENDING_DOCUMENTS_INCLUDE' | translate}}
    </button>
  </div>
</ng-container>
</div>
